import createIcon from '../../createIcon';

/**
 * @component @name LockClock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAxNC4yTDE3LjQgMTUuOUwxNi42IDE3LjJMMTMgMTVWMTBIMTQuNVYxNC4yWk0yMiAxNEMyMiAxOC40MSAxOC40MSAyMiAxNCAyMkMxMS45OCAyMiAxMC4xNCAyMS4yNCA4LjczIDIwSDRDMi44NSAyMCAyIDE5LjE1IDIgMThWOUMyIDcuODggMi44OSA3LjA0IDQgN1Y2LjVDNCA0LjAxIDYuMDEgMiA4LjUgMkMxMC44NCAyIDEyLjc0IDMuNzkgMTIuOTYgNi4wOEMxMy4zIDYuMDMgMTMuNjUgNiAxNCA2QzE4LjQxIDYgMjIgOS41OSAyMiAxNFpNNiA3SDExVjYuMjZDMTAuODggNC45OSA5LjggNCA4LjUgNEM3LjEyIDQgNiA1LjEyIDYgNi41VjdaTTIwIDE0QzIwIDEwLjY5IDE3LjMxIDggMTQgOEMxMC42OSA4IDggMTAuNjkgOCAxNEM4IDE3LjMxIDEwLjY5IDIwIDE0IDIwQzE3LjMxIDIwIDIwIDE3LjMxIDIwIDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LockClock = createIcon('LockClock', [
  [
    'path',
    {
      d: 'M14.5 14.2L17.4 15.9L16.6 17.2L13 15V10H14.5V14.2ZM22 14C22 18.41 18.41 22 14 22C11.98 22 10.14 21.24 8.73 20H4C2.85 20 2 19.15 2 18V9C2 7.88 2.89 7.04 4 7V6.5C4 4.01 6.01 2 8.5 2C10.84 2 12.74 3.79 12.96 6.08C13.3 6.03 13.65 6 14 6C18.41 6 22 9.59 22 14ZM6 7H11V6.26C10.88 4.99 9.8 4 8.5 4C7.12 4 6 5.12 6 6.5V7ZM20 14C20 10.69 17.31 8 14 8C10.69 8 8 10.69 8 14C8 17.31 10.69 20 14 20C17.31 20 20 17.31 20 14Z',
      key: 'zs9spv',
    },
  ],
]);

export default LockClock;
